import React from 'react';

const CollapsableContentDesc = ({ children }) => (
  <p className="collapsableContent-body-desc">{children}</p>
);

export default CollapsableContentDesc;
